import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Pagination from "../../../entities/Pagination";
import Transaction from "../../../entities/Transaction";
import {TransactionService} from "../../../service/TransactionService";
import TransactionStatus from "../../../entities/TransactionStatus";
import Currency from "../../../entities/Currency";

class ViewTransactionsStore {

    public entityId: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    public pagination: Pagination;
    public transactions: Transaction[];
    public from?: number;
    public to?: number;
    public status?: TransactionStatus;
    public currency?: Currency;
    public transactionTypeFilter?: string;


    constructor(commonStore: CommonStore, entityId: string) {
        this.entityId = entityId;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 10, 0, 0);
        this.transactions = [];
        makeAutoObservable(this);
    }

    @action
    public async searchBalanceTransations(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.loading = true;
        const response = await TransactionService.get(
            this.entityId,
            page,
            pageSize,
            this.from,
            this.to,
            this.status,
            this.currency,
            this.transactionTypeFilter
        );
        if (response.success) {
            runInAction(() => {
                this.transactions = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        await this.searchBalanceTransations();
    }

    @action
    public async cleanFilter() {
        this.currency = undefined;
        this.from = undefined;
        this.to = undefined;
        this.transactionTypeFilter = undefined;
        await this.searchBalanceTransations();
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    get isEmpty(): boolean {
        return this.transactions.length === 0;
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.searchBalanceTransations(page, pageSize);
    }

}

export default ViewTransactionsStore;